var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page" }, [
    _c(
      "div",
      { staticClass: "page-content" },
      [
        _c("page-nav-bar", {
          attrs: {
            currentServiceName: "MoneyRoad",
            subNavTitle: "Application Settings",
            returnPreviousPage: false,
          },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "layoutTop" }),
        _vm._v(" "),
        _c("div", { staticClass: "container-fluid" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-6 offset-md-3" }, [
              _c("div", { staticClass: "panel21 panel-default" }, [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "ul",
                  [
                    _c(
                      "form-accordion",
                      { attrs: { open: "", title: "GENERAL" } },
                      [
                        _c("div", { staticClass: "form-group " }, [
                          _c("label", { staticClass: "col-form-label" }, [
                            _vm._v("Receive Modular Loan Email"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "label-switch",
                              class: _vm.labelSwitchColorClass,
                            },
                            [
                              _c("input", {
                                staticClass: "checkboxSendPaymentsRequestEmail",
                                attrs: { type: "checkbox" },
                                domProps: {
                                  value: _vm.sendPaymentRequestEmail,
                                },
                                on: {
                                  change: _vm.switchSendPaymentsRequestEmail,
                                },
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "checkbox" }),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-group " }, [
                          _c("label", { staticClass: "col-form-label" }, [
                            _vm._v(_vm._s(_vm.$t("settings.activate_OCR"))),
                          ]),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "label-switch",
                              class: _vm.labelSwitchColorClass,
                            },
                            [
                              _c("input", {
                                staticClass: "checkboxOcrActivation",
                                attrs: { type: "checkbox" },
                                domProps: { value: _vm.ocrActivation },
                                on: { change: _vm.changeSwitchOcrActivation },
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "checkbox" }),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-group " }, [
                          _c("label", { staticClass: "col-form-label" }, [
                            _vm._v("Generate Bank Transfer Order"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "label-switch",
                              class: _vm.labelSwitchColorClass,
                            },
                            [
                              _c("input", {
                                staticClass: "checkboxIsToGenerateXML",
                                attrs: { type: "checkbox" },
                                domProps: { value: _vm.isToGenerateXML },
                                on: { change: _vm.changeSwitchIsToGenerateXML },
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "checkbox" }),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-group " }, [
                          _c("label", { staticClass: "col-form-label" }, [
                            _vm._v("Validation amount"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "item-after" }, [
                            _vm._v(_vm._s(_vm.validationThreshold)),
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.validationThreshold,
                                expression: "validationThreshold",
                              },
                            ],
                            staticClass: "range-slider-streammind",
                            class: _vm.sliderColorClass,
                            attrs: {
                              type: "range",
                              min: "0",
                              max: "15000",
                              value: "0",
                              step: "10",
                            },
                            domProps: { value: _vm.validationThreshold },
                            on: {
                              __r: function ($event) {
                                _vm.validationThreshold = $event.target.value
                              },
                            },
                          }),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _c(
                  "ul",
                  [
                    _c(
                      "form-accordion",
                      { attrs: { open: "", title: "PAYMENT METHOD" } },
                      [
                        _c("div", { staticClass: "form-group row" }, [
                          _c(
                            "div",
                            { staticClass: "form-group  col-sm-auto" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "custom-control custom-radio custom-control-inline",
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.paymentsMethod,
                                        expression: "paymentsMethod",
                                      },
                                    ],
                                    staticClass: "custom-control-input",
                                    attrs: {
                                      id: "defaultInline1",
                                      type: "radio",
                                      name: "methodRadio",
                                      value: "application",
                                      checked: "",
                                    },
                                    domProps: {
                                      checked: _vm._q(
                                        _vm.paymentsMethod,
                                        "application"
                                      ),
                                    },
                                    on: {
                                      change: function ($event) {
                                        _vm.paymentsMethod = "application"
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "custom-control-label",
                                      attrs: { for: "defaultInline1" },
                                    },
                                    [_vm._v("Credit transfer")]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "custom-control custom-radio custom-control-inline",
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.paymentsMethod,
                                        expression: "paymentsMethod",
                                      },
                                    ],
                                    staticClass: "custom-control-input",
                                    attrs: {
                                      id: "defaultInline2",
                                      type: "radio",
                                      name: "methodRadio",
                                      value: "bankCard",
                                    },
                                    domProps: {
                                      checked: _vm._q(
                                        _vm.paymentsMethod,
                                        "bankCard"
                                      ),
                                    },
                                    on: {
                                      change: function ($event) {
                                        _vm.paymentsMethod = "bankCard"
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "custom-control-label",
                                      attrs: { for: "defaultInline2" },
                                    },
                                    [_vm._v("Bank card")]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _c(
                  "ul",
                  [
                    _c(
                      "form-accordion",
                      { attrs: { open: "", title: "Negotiation" } },
                      [
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", { staticClass: "col-form-label" }, [
                            _vm._v("Enable Installment Rules"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "label-switch",
                              class: _vm.labelSwitchColorClass,
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.enableInstallmentRules,
                                    expression: "enableInstallmentRules",
                                  },
                                ],
                                attrs: { type: "checkbox" },
                                domProps: {
                                  checked: Array.isArray(
                                    _vm.enableInstallmentRules
                                  )
                                    ? _vm._i(_vm.enableInstallmentRules, null) >
                                      -1
                                    : _vm.enableInstallmentRules,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = _vm.enableInstallmentRules,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.enableInstallmentRules =
                                            $$a.concat([$$v]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.enableInstallmentRules = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.enableInstallmentRules = $$c
                                    }
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "checkbox" }),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-group " }, [
                          _c("label", { staticClass: "col-form-label" }, [
                            _vm._v("Allow negotiation as default"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "label-switch",
                              class: _vm.labelSwitchColorClass,
                            },
                            [
                              _c("input", {
                                staticClass:
                                  "checkboxDefaultNegotiationAllowed",
                                attrs: { type: "checkbox" },
                                domProps: {
                                  value: _vm.defaultNegotiationAllowed,
                                },
                                on: {
                                  change:
                                    _vm.changeSwitchDefaultNegotiationAllowed,
                                },
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "checkbox" }),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", { staticClass: "col-form-label" }, [
                            _vm._v(
                              "Authorise contact to edit installments as default"
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "label-switch",
                              class: _vm.labelSwitchColorClass,
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.defaultModificationInstallmentsAllowed,
                                    expression:
                                      "defaultModificationInstallmentsAllowed",
                                  },
                                ],
                                attrs: { type: "checkbox" },
                                domProps: {
                                  checked: Array.isArray(
                                    _vm.defaultModificationInstallmentsAllowed
                                  )
                                    ? _vm._i(
                                        _vm.defaultModificationInstallmentsAllowed,
                                        null
                                      ) > -1
                                    : _vm.defaultModificationInstallmentsAllowed,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a =
                                        _vm.defaultModificationInstallmentsAllowed,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.defaultModificationInstallmentsAllowed =
                                            $$a.concat([$$v]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.defaultModificationInstallmentsAllowed =
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.defaultModificationInstallmentsAllowed =
                                        $$c
                                    }
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "checkbox" }),
                            ]
                          ),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              {
                staticClass: "col-md-2 offset-md-7",
                class: _vm.colorBottomButton,
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "button-action firstButtonMarginTop",
                    attrs: { round: "" },
                    on: { click: _vm.changeApplicationSettings },
                  },
                  [
                    _c("i", { staticClass: "icon fa fa-save" }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Save")]),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "toolbarPageBottomBlank" }),
              ]
            ),
          ]),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "panel-heading" }, [
      _c("h4", { staticClass: "content-block labelAccordionForm" }, [
        _c("img", {
          staticClass: "formIcon",
          attrs: {
            src: require("../../assets/static/images/icons/gearwheels.png"),
          },
        }),
        _vm._v("\n                    SETTING\n                "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }